(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["jf-breadcrumb"] && !Shopify.designMode) return;
  try {
    (function () {
    // Læg brødkrummen øverst i produktbilledets (sticky) kolonne, så den følger billedet.
    function place() {
      document.querySelectorAll('[data-jf-bc-source]').forEach(function (source) {
        var section = source.closest('.shopify-section') || document;
        var gallery = section.querySelector('media-gallery');
        if (!gallery) return;

        var placed = gallery.querySelector(':scope > .jf-bc--placed');
        if (placed) return;

        var nav = source.querySelector('.jf-bc');
        if (!nav) return;

        var clone = nav.cloneNode(true);
        clone.classList.add('jf-bc--placed');
        gallery.insertBefore(clone, gallery.firstChild);
      });
    }

    function watch() {
      place();
      document.querySelectorAll('[data-jf-bc-source]').forEach(function (source) {
        var section = source.closest('.shopify-section');
        if (!section || section.dataset.jfBcObserved) return;
        section.dataset.jfBcObserved = 'true';
        // Hvis Horizon genopbygger billedgalleriet (fx ved variantskift), placeres brødkrummen igen.
        new MutationObserver(function () {
          place();
        }).observe(section, { childList: true, subtree: true });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', watch);
    } else {
      watch();
    }

    document.addEventListener('shopify:section:load', function () {
      setTimeout(watch, 0);
    });
    document.addEventListener('shopify:block:select', function () {
      setTimeout(place, 0);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["jf-step-guide"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.customElements.get('jf-step-guide')) return;

    class JfStepGuide extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.onClick.bind(this));
        this.autoplay = this.dataset.autoplay === 'true';
        this.inView = false;
        this.soundOn = false;

        if (!this.autoplay) return;

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            this.inView = entries[0].isIntersecting;
            if (this.inView) {
              this.playActive();
            } else {
              this.pauseAll();
            }
          }, { threshold: 0.25 });
          this.observer.observe(this);
        } else {
          this.inView = true;
          this.playActive();
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      pauseAll() {
        this.querySelectorAll('video').forEach(function (v) {
          v.pause();
        });
      }

      playActive() {
        const media = this.querySelector('[data-jf-sg-media].jf-sg--active');
        const video = media && media.querySelector('video');
        if (!video) return;
        video.muted = !this.soundOn;
        video.play().catch(function () {});
      }

      onClick(event) {
        const sound = event.target.closest('[data-jf-sg-sound]');
        if (sound && this.contains(sound)) {
          this.toggleSound();
          return;
        }
        const play = event.target.closest('[data-jf-sg-play]');
        if (play && this.contains(play)) {
          this.playVideo(play.closest('[data-jf-sg-media]'));
          return;
        }
        const tab = event.target.closest('[data-jf-sg-tab]');
        if (tab && this.contains(tab)) {
          this.activate(tab.dataset.index);
        }
      }

      // Lyden gælder hele guiden, så den følger med, når man skifter trin.
      toggleSound() {
        this.soundOn = !this.soundOn;
        const onLabel = this.dataset.soundOnLabel || 'Slå lyd til';
        const offLabel = this.dataset.soundOffLabel || 'Slå lyd fra';

        this.querySelectorAll('[data-jf-sg-media]').forEach((media) => {
          const video = media.querySelector('video');
          if (!video) return;
          const isActive = media.classList.contains('jf-sg--active');
          video.muted = isActive ? !this.soundOn : true;
        });

        this.querySelectorAll('[data-jf-sg-sound]').forEach((btn) => {
          btn.classList.toggle('jf-sg--on', this.soundOn);
          btn.setAttribute('aria-pressed', this.soundOn ? 'true' : 'false');
          btn.setAttribute('aria-label', this.soundOn ? offLabel : onLabel);
        });

        const active = this.querySelector('[data-jf-sg-media].jf-sg--active video');
        if (active && this.autoplay) active.play().catch(function () {});
      }

      playVideo(media) {
        if (!media) return;
        const wrap = media.querySelector('[data-jf-sg-video-wrap]');
        const video = wrap && wrap.querySelector('video');
        const pill = media.querySelector('[data-jf-sg-play]');
        if (!video) return;
        wrap.hidden = false;
        if (pill) pill.hidden = true;
        video.play().catch(function () {});
      }

      activate(index) {
        this.querySelectorAll('video').forEach(function (v) {
          v.pause();
        });
        this.querySelectorAll('[data-jf-sg-media], [data-jf-sg-panel]').forEach(function (el) {
          el.classList.toggle('jf-sg--active', el.dataset.index === index);
        });
        this.querySelectorAll('[data-jf-sg-tab]').forEach(function (tab) {
          const active = tab.dataset.index === index;
          tab.classList.toggle('jf-sg--active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        if (this.autoplay) {
          this.querySelectorAll('[data-jf-sg-media]').forEach(function (media) {
            if (media.dataset.index === index) return;
            const video = media.querySelector('video');
            if (video) {
              video.currentTime = 0;
              video.muted = true;
            }
          });
          if (this.inView) this.playActive();
          return;
        }

        this.querySelectorAll('[data-jf-sg-media]').forEach(function (media) {
          if (media.dataset.index === index) return;
          const wrap = media.querySelector('[data-jf-sg-video-wrap]');
          const pill = media.querySelector('[data-jf-sg-play]');
          if (wrap) wrap.hidden = true;
          if (pill) pill.hidden = false;
        });
      }
    }

    window.customElements.define('jf-step-guide', JfStepGuide);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ka-dispatch-notice"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__kaDispatchInit) return;
    window.__kaDispatchInit = true;

    function parseCutoff(raw) {
      const parts = String(raw || '14').split(/[:.]/);
      return { h: parseInt(parts[0], 10) || 14, m: parseInt(parts[1], 10) || 0 };
    }

    function key(date) {
      return (
        date.getFullYear() +
        '-' +
        String(date.getMonth() + 1).padStart(2, '0') +
        '-' +
        String(date.getDate()).padStart(2, '0')
      );
    }

    /* ISO weekday: Mon=1 .. Sun=7 */
    function isoDay(date) {
      return date.getDay() === 0 ? 7 : date.getDay();
    }

    function danishDate(date) {
      const weekday = new Intl.DateTimeFormat('da-DK', { weekday: 'long' }).format(date);
      const month = new Intl.DateTimeFormat('da-DK', { month: 'long' }).format(date);
      return weekday + ' d. ' + date.getDate() + '. ' + month;
    }

    function decorate(el) {
      const msgEl = el.querySelector('[data-ka-dispatch-msg]');
      if (!msgEl) return;

      const days = (el.dataset.days || '').split(',').filter(Boolean).map(Number);
      const holidays = (el.dataset.holidays || '').split(/[\s,;]+/).filter(Boolean);
      const cutoff = parseCutoff(el.dataset.cutoff);
      const transit = parseInt(el.dataset.transit, 10) || 0;
      if (!days.length) return;

      const now = new Date();

      /* Next dispatch occasion, scanning up to 30 days ahead. */
      let dispatch = null;
      let isToday = false;
      for (let i = 0; i < 30; i++) {
        const candidate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + i);
        if (!days.includes(isoDay(candidate)) || holidays.includes(key(candidate))) continue;
        if (i === 0) {
          const beforeCutoff = now.getHours() < cutoff.h || (now.getHours() === cutoff.h && now.getMinutes() < cutoff.m);
          if (!beforeCutoff) continue;
          isToday = true;
        }
        dispatch = candidate;
        break;
      }
      if (!dispatch) return;

      /* Delivery estimate: dispatch + transit days, skipping weekends & holidays. */
      const delivery = new Date(dispatch);
      let left = transit;
      while (left > 0) {
        delivery.setDate(delivery.getDate() + 1);
        if (isoDay(delivery) <= 5 && !holidays.includes(key(delivery))) left--;
      }

      const tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
      let dayLabel;
      if (key(dispatch) === key(tomorrow)) {
        dayLabel = 'i morgen';
      } else {
        dayLabel = new Intl.DateTimeFormat('da-DK', { weekday: 'long' }).format(dispatch);
      }

      const template = isToday ? el.dataset.tToday : el.dataset.tLater;
      if (!template) return;

      msgEl.textContent = template
        .replace('[cutoff]', el.dataset.cutoff || '14')
        .replace('[day]', dayLabel)
        .replace('[date]', danishDate(delivery));
      msgEl.hidden = false;
    }

    function decorateAll() {
      document.querySelectorAll('[data-ka-dispatch]').forEach(decorate);
    }

    /* Variant switch: swap this block from the new-variant document so
       availability gating follows the selected variant, then recompute. */
    document.addEventListener('shopify:product:select', function (event) {
      if (!event.promise || !document.querySelector('[data-ka-dispatch]')) return;
      event.promise
        .then(function (payload) {
          const doc = payload && payload.detail && payload.detail.html;
          if (!doc) return;
          document.querySelectorAll('[data-ka-dispatch]').forEach(function (el) {
            const fresh = doc.querySelector('[data-ka-dispatch][data-block-id="' + el.dataset.blockId + '"]');
            /* Skip identical content — avoids a needless repaint (blink). */
            if (fresh && fresh.innerHTML !== el.innerHTML) {
              el.replaceChildren.apply(el, Array.from(fresh.cloneNode(true).childNodes));
            }
          });
          decorateAll();
        })
        .catch(function () {});
    });

    document.addEventListener('shopify:section:load', decorateAll);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', decorateAll);
    } else {
      decorateAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ka-product-badges"] && !Shopify.designMode) return;
  try {
    (function () {
    // Læg badges oven på produktbilledet. Ankeret er billedets viewport
    // (slideshow-container), så badges ikke lander oven på miniaturerne.
    function anchorFor(gallery) {
      return (
        gallery.querySelector('slideshow-container') ||
        gallery.querySelector('.product-media-container') ||
        gallery
      );
    }

    function place() {
      document.querySelectorAll('[data-ka-badges-source]').forEach(function (source) {
        var section = source.closest('.shopify-section') || document;
        var gallery = section.querySelector('media-gallery');
        if (!gallery) return;

        var badges = source.querySelector('.ka-badges');
        if (!badges) return;

        var sig = source.dataset.kaBadgesSig || '';
        var placed = gallery.querySelector('.ka-badges--placed[data-ka-badges-sig="' + sig + '"]');
        if (placed) return;

        // Ryd kun op efter denne blok (signaturen starter med blokkens id),
        // så flere badge-blokke på samme side ikke fjerner hinandens badges.
        var owner = sig.split(':')[0] + ':';
        gallery.querySelectorAll('.ka-badges--placed').forEach(function (stale) {
          if ((stale.getAttribute('data-ka-badges-sig') || '').indexOf(owner) === 0) stale.remove();
        });

        var corner = source.dataset.kaBadgesCorner || 'top-left';
        var offset = source.dataset.kaBadgesOffset || '10';

        var clone = badges.cloneNode(true);
        clone.classList.add('ka-badges--placed', 'ka-badges--' + corner);
        clone.setAttribute('data-ka-badges-sig', sig);
        clone.style.setProperty('--ka-placed-offset', offset + 'px');

        var anchor = anchorFor(gallery);
        if (getComputedStyle(anchor).position === 'static') {
          anchor.style.position = 'relative';
        }
        anchor.appendChild(clone);
      });
    }

    function watch() {
      place();
      document.querySelectorAll('[data-ka-badges-source]').forEach(function (source) {
        var section = source.closest('.shopify-section');
        if (!section || section.dataset.kaBadgesObserved) return;
        section.dataset.kaBadgesObserved = 'true';
        // Hvis Horizon genopbygger billedgalleriet (fx ved variantskift), placeres badges igen.
        new MutationObserver(function () {
          place();
        }).observe(section, { childList: true, subtree: true });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', watch);
    } else {
      watch();
    }

    document.addEventListener('shopify:section:load', function () {
      setTimeout(watch, 0);
    });
    document.addEventListener('shopify:block:select', function () {
      setTimeout(place, 0);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ka-promo-notice"] && !Shopify.designMode) return;
  try {
    (function () {
    /* The theme editor re-executes block javascript on every re-render —
       a color-picker drag re-renders continuously. Without this guard each
       re-run stacked another document-wide listener and another /cart.js
       fetch, freezing the preview. Listeners attach once per page. */
    if (window.__kaPromoGiftInit) return;
    window.__kaPromoGiftInit = true;

    const SOURCE = 'ka-promo-gift';
    let selfDispatch = false;

    function root() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    /* Discover which Horizon sections carry cart UI, so the server re-renders them. */
    function cartSectionIds() {
      const ids = new Set();
      const nodes = document.querySelectorAll(
        'cart-drawer-component, cart-icon-component, cart-items-component, cart-summary-component, .cart-bubble'
      );
      nodes.forEach(function (el) {
        const wrapper = el.closest('[id^="shopify-section-"]');
        if (wrapper) ids.add(wrapper.id.replace('shopify-section-', ''));
      });
      return Array.from(ids);
    }

    function applySections(sections) {
      if (!sections) return;
      Object.keys(sections).forEach(function (id) {
        const target = document.getElementById('shopify-section-' + id);
        if (!target || typeof sections[id] !== 'string') return;
        const parsed = new DOMParser().parseFromString(sections[id], 'text/html');
        const fresh = parsed.getElementById('shopify-section-' + id);
        if (fresh) target.replaceWith(fresh);
      });
    }

    function notifyHorizon(cart, variantId) {
      selfDispatch = true;
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: SOURCE,
            data: {
              source: SOURCE,
              sections: cart.sections,
              itemCount: cart.item_count,
              didError: false,
              variantId: String(variantId)
            }
          }
        })
      );
      setTimeout(function () {
        selfDispatch = false;
      }, 0);
    }

    function setState(wrap, state) {
      const btn = wrap.querySelector('[data-ka-promo-add]');
      if (!btn) return;
      const label = btn.querySelector('[data-ka-promo-label]') || btn;
      if (state === 'added') {
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
        label.textContent = wrap.dataset.labelAdded;
      } else if (state === 'available') {
        btn.disabled = false;
        btn.removeAttribute('aria-disabled');
        label.textContent = wrap.dataset.labelCta;
      }
    }

    /* Reconcile against the live cart — Liquid-rendered state can be served from cache. */
    function reconcile() {
      const wraps = document.querySelectorAll('[data-ka-promo]');
      if (!wraps.length) return;
      fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          const ids = (cart.items || []).map(function (i) {
            return String(i.variant_id);
          });
          wraps.forEach(function (wrap) {
            const btn = wrap.querySelector('[data-ka-promo-add]');
            if (!btn) return;
            const isInCart = ids.indexOf(String(wrap.dataset.variantId)) !== -1;
            if (isInCart) {
              setState(wrap, 'added');
            } else if (btn.dataset.soldOut !== 'true') {
              setState(wrap, 'available');
            }
          });
        })
        .catch(function () {});
    }

    document.addEventListener('click', function (event) {
      const btn = event.target.closest('[data-ka-promo-add]');
      if (!btn || btn.disabled) return;

      const wrap = btn.closest('[data-ka-promo]');
      if (!wrap) return;

      const label = btn.querySelector('[data-ka-promo-label]') || btn;
      const original = label.textContent;
      const variantId = Number(wrap.dataset.variantId);
      const sections = cartSectionIds();

      btn.disabled = true;
      label.textContent = '…';

      fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: sections.join(','),
          sections_url: window.location.pathname
        })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('cart/add failed');
          return res.json();
        })
        .then(function () {
          /* Authoritative cart + freshly rendered sections. */
          return fetch(root() + 'cart.js?sections=' + encodeURIComponent(sections.join(',')), {
            headers: { Accept: 'application/json' }
          }).then(function (res) {
            return res.json();
          });
        })
        .then(function (cart) {
          applySections(cart.sections);
          notifyHorizon(cart, variantId);
          setState(wrap, 'added');
          if (wrap.dataset.openDrawer === 'true') {
            document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
          }
        })
        .catch(function () {
          label.textContent = original;
          btn.disabled = false;
        });
    });

    /* If the gift is removed elsewhere (drawer, cart page), re-enable the CTA. */
    document.addEventListener('cart:update', function () {
      if (selfDispatch) return;
      reconcile();
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', reconcile);
    } else {
      reconcile();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ka-routine-notice"] && !Shopify.designMode) return;
  try {
    (function () {
    /* The theme editor re-executes block javascript on every re-render —
       guard so listeners attach once per page. */
    if (window.__kaRoutineNoticeInit) return;
    window.__kaRoutineNoticeInit = true;

    const SOURCE = 'ka-routine-notice';

    function root() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    /* Horizon 4.1+ cart components (cart-icon, cart-drawer-component,
       cart-items-component) listen for the @shopify/events
       CartLinesUpdateEvent ('shopify:cart:lines-update'), which carries a
       promise they await for {cart, detail}. The legacy 'cart:update'
       CustomEvent no longer updates anything in core — this mirrors the
       exact flow of core assets/product-form.js. */

    function cartSectionIds() {
      const ids = new Set();
      document.querySelectorAll('cart-items-component').forEach(function (el) {
        if (el.dataset.sectionId) ids.add(el.dataset.sectionId);
      });
      return Array.from(ids);
    }

    function openCartDrawer() {
      const drawerComponent = document.querySelector('cart-drawer-component');
      const drawer = drawerComponent && drawerComponent.closest('theme-drawer');
      if (drawer && typeof drawer.open === 'function' && !drawer.hasAttribute('open')) {
        drawer.open();
      }
    }

    /* Legacy event for the other KA blocks (promo gift, gift wrap, shipping
       bar) that reconcile their own state on 'cart:update'. */
    function notifyLegacy(cart, sections, variantId) {
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: SOURCE,
            data: {
              source: SOURCE,
              sections: sections,
              itemCount: cart.item_count,
              didError: false,
              variantId: String(variantId)
            }
          }
        })
      );
    }

    document.addEventListener('click', function (event) {
      const btn = event.target.closest('[data-ka-rn-add]');
      if (!btn || btn.disabled) return;

      const wrap = btn.closest('[data-ka-rn]');
      if (!wrap) return;

      const label = btn.querySelector('[data-ka-rn-label]') || btn;
      const original = label.textContent;
      const variantId = Number(wrap.dataset.variantId);
      if (!variantId) return;

      btn.disabled = true;
      label.textContent = '…';

      function done() {
        label.textContent = original;
        btn.disabled = false;
      }

      import('@shopify/events')
        .then(function (events) {
          const CartLinesUpdateEvent = events.CartLinesUpdateEvent;
          const deferred = CartLinesUpdateEvent.createPromise();
          const sections = cartSectionIds();

          /* Dispatch before the fetch (like core product-form.js) — the
             components hold onto the promise and update when it resolves. */
          btn.dispatchEvent(
            new CartLinesUpdateEvent({
              action: 'add',
              context: 'product',
              lines: [{ merchandiseId: String(variantId), quantity: 1 }],
              promise: deferred.promise
            })
          );

          return fetch(root() + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: variantId, quantity: 1 }],
              sections: sections.join(','),
              sections_url: window.location.pathname
            })
          })
            .then(function (res) {
              return res.json().then(function (data) {
                if (!res.ok || data.status) throw new Error((data && data.message) || 'cart/add failed');
                return data;
              });
            })
            .then(function (addResponse) {
              /* Authoritative full cart for the event's cart payload. */
              return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
                .then(function (res) {
                  return res.json();
                })
                .then(function (ajaxCart) {
                  deferred.resolve({
                    cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
                    detail: {
                      items: ajaxCart.items,
                      source: SOURCE,
                      itemCount: ajaxCart.item_count,
                      sections: addResponse.sections,
                      didError: false
                    }
                  });
                  notifyLegacy(ajaxCart, addResponse.sections, variantId);
                  if (wrap.dataset.openDrawer === 'true') {
                    openCartDrawer();
                  }
                  done();
                });
            })
            .catch(function (error) {
              deferred.reject(error);
              done();
            });
        })
        .catch(done);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ka-shipping-bar"] && !Shopify.designMode) return;
  try {
    (function () {
    /* PDP projection mode only: keep the bar in sync without a reload.
       Cart changes -> re-render this block via the Section Rendering API
       (server Liquid stays the single source of truth for the math).
       Variant switches -> swap in the counterpart from the new-variant
       document that Horizon's variant picker already fetched. */
    if (window.__kaShippingBarProjInit) return;
    window.__kaShippingBarProjInit = true;

    let timer = null;

    /* Section Rendering API re-render — unlike full-page HTML this is not
       served from the page cache, so its cart state is trustworthy. An
       explicit variant id can be passed on variant switches. */
    function refetch(variantId) {
      document.querySelectorAll('[data-ka-sb-project]').forEach(function (el) {
        const sectionId = el.dataset.sectionId;
        const blockId = el.dataset.kaSbBlock;
        if (!sectionId || !blockId) return;
        const params = new URLSearchParams(window.location.search);
        if (variantId) params.set('variant', String(variantId));
        params.set('section_id', sectionId);
        fetch(window.location.pathname + '?' + params.toString(), {
          headers: { Accept: 'text/html' }
        })
          .then(function (res) {
            return res.text();
          })
          .then(function (html) {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const fresh = doc.querySelector('[data-ka-sb-block="' + blockId + '"]');
            const current = document.querySelector('[data-ka-sb-block="' + blockId + '"]');
            if (fresh && current) current.replaceWith(fresh);
          })
          .catch(function () {});
      });
    }

    function currentVariantId() {
      const input = document.querySelector('product-form-component form [name="id"]');
      return input ? input.value : null;
    }

    function scheduleRefetch(variantId) {
      if (!document.querySelector('[data-ka-sb-project]')) return;
      clearTimeout(timer);
      timer = setTimeout(function () {
        refetch(variantId || currentVariantId());
      }, 150);
    }

    /* Horizon 4.1+ standard cart event — wait for the operation to finish. */
    document.addEventListener('shopify:cart:lines-update', function (event) {
      if (event.promise && typeof event.promise.then === 'function') {
        event.promise
          .then(function () {
            scheduleRefetch();
          })
          .catch(function () {});
      } else {
        scheduleRefetch();
      }
    });
    /* Legacy event dispatched by the KA cart blocks after completion. */
    document.addEventListener('cart:update', function () {
      scheduleRefetch();
    });

    /* Variant switch: the new-variant DOCUMENT can come from the page cache
       with stale cart state, so never swap the bar from it — re-render via
       the Section Rendering API with the new variant id instead. */
    document.addEventListener('shopify:product:select', function (event) {
      if (!event.promise || !document.querySelector('[data-ka-sb-project]')) return;
      event.promise
        .then(function (payload) {
          let vid = payload && payload.variant && payload.variant.id;
          if (vid) vid = String(vid).split('/').pop();
          scheduleRefetch(vid);
        })
        .catch(function () {});
    });

    /* The initially served page itself can be cache-stale on cart state —
       reconcile once against the live cart and re-render on mismatch. */
    function reconcile() {
      const el = document.querySelector('[data-ka-sb-project]');
      if (!el) return;
      fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart.js', {
        headers: { Accept: 'application/json' }
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          if (String(cart.total_price) !== el.dataset.cartTotal) {
            refetch(currentVariantId());
          }
        })
        .catch(function () {});
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', reconcile);
    } else {
      reconcile();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ka-usage-time"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__kaUsageTimeInit) return;
    window.__kaUsageTimeInit = true;

    /* Swap from the new-variant document Horizon already fetched — variant
       metafields are variant-scoped, so that document is authoritative for
       them (unlike cart state). Listen on document: the block may live in a
       different section than the variant picker. */
    document.addEventListener('shopify:product:select', function (event) {
      if (!event.promise || !document.querySelector('[data-ka-ut]')) return;
      event.promise
        .then(function (payload) {
          const doc = payload && payload.detail && payload.detail.html;
          if (!doc) return;
          document.querySelectorAll('[data-ka-ut]').forEach(function (el) {
            const fresh = doc.querySelector('[data-ka-ut][data-block-id="' + el.dataset.blockId + '"]');
            /* Skip identical content — avoids a needless repaint (blink). */
            if (fresh && fresh.innerHTML !== el.innerHTML) {
              el.replaceChildren.apply(el, Array.from(fresh.cloneNode(true).childNodes));
            }
          });
        })
        .catch(function () {});
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ka-variant-picker"] && !Shopify.designMode) return;
  try {
    (function () {
    /* Size cards decoration: meta line (unit price and/or tagline), badges
       and scroll fades on top of the core variant picker markup. Runs on load
       and again after every variant-switch morph (the morph wipes injected
       nodes). */
    if (window.__kaVpCardsInit) return;
    window.__kaVpCardsInit = true;

    function updateFades(row) {
      const canLeft = row.scrollLeft > 4;
      const canRight = row.scrollLeft + row.clientWidth < row.scrollWidth - 4;
      row.classList.toggle('ka-fade-left', canLeft);
      row.classList.toggle('ka-fade-right', canRight);
    }

    /* Unit price first, then tagline — "1,10 kr/ml · rejse". Either part may
       be empty (setting turned off, or no metafield / no usable amount). */
    function buildMeta(info, sep) {
      const meta = document.createElement('span');
      meta.className = 'ka-vp-card__meta';

      if (info.u) {
        const unit = document.createElement('span');
        unit.className = 'ka-vp-card__meta-unit';
        unit.textContent = info.u;
        meta.appendChild(unit);
      }
      if (info.u && info.t) {
        meta.appendChild(document.createTextNode(sep));
      }
      if (info.t) {
        const tagline = document.createElement('span');
        tagline.className = 'ka-vp-card__meta-tagline';
        tagline.textContent = info.t;
        meta.appendChild(tagline);
      }
      return meta;
    }

    function decorate() {
      document.querySelectorAll('.ka-variant-picker--cards').forEach(function (wrap) {
        const dataEl = wrap.querySelector('[data-ka-vp-data]');
        if (!dataEl) return;
        let data;
        try {
          data = JSON.parse(dataEl.textContent);
        } catch (e) {
          return;
        }
        const sep = typeof data.sep === 'string' && data.sep !== '' ? data.sep : ' · ';

        wrap.querySelectorAll('.variant-option__button-label').forEach(function (label) {
          const input = label.querySelector('input');
          const info = input && data.values[input.value];
          if (!info) return;

          if ((info.u || info.t) && !label.querySelector('.ka-vp-card__meta')) {
            label.appendChild(buildMeta(info, sep));
          }

          const badgeText = info.a === false ? data.soldout : info.b;
          if (badgeText && !label.querySelector('.ka-vp-card__badge')) {
            const badge = document.createElement('span');
            badge.className = 'ka-vp-card__badge' + (info.a === false ? ' ka-vp-card__badge--soldout' : '');
            badge.textContent = badgeText;
            label.appendChild(badge);
          }
        });

        if (wrap.classList.contains('ka-vp--scroll')) {
          const row = wrap.querySelector('.variant-option--buttons');
          if (row) {
            if (!row.__kaFadeBound) {
              row.__kaFadeBound = true;
              row.addEventListener('scroll', function () {
                updateFades(row);
              }, { passive: true });
            }
            updateFades(row);
          }
        }
      });
    }

    /* The variant-switch morph rebuilds the option buttons on its own async
       schedule (racing any event listener), so watch the DOM instead.
       Decorate SYNCHRONOUSLY: observer callbacks are microtasks that run
       before the next paint, so the undecorated state never flashes.
       decorate() is idempotent, so the observer settles after one pass. */
    const observer = new MutationObserver(function () {
      decorate();
    });

    function observeAll() {
      document.querySelectorAll('.ka-variant-picker--cards').forEach(function (wrap) {
        if (wrap.__kaVpObserved) return;
        wrap.__kaVpObserved = true;
        observer.observe(wrap, { childList: true, subtree: true });
      });
    }

    function boot() {
      decorate();
      observeAll();
    }

    document.addEventListener('shopify:section:load', boot);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["klejn-gift-wrap"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__klejnGwInit) return;
    window.__klejnGwInit = true;

    const PRODUCT_PROP = 'Modtager';
    const WRAP_PROP = 'Indpakkes til';
    const VARIANT_ATTR = '_klejn_gw_variant';
    const SYNC_DEBOUNCE_MS = 200;
    const INTERNAL_HEADER = 'X-Klejn-Gw-Internal';

    let syncTimer = null;
    let syncing = false;
    let isSelfDispatch = false;
    const originalFetch = window.fetch.bind(window);

    function init() {
      patchFetch();
      setupBlocks();
      const observer = new MutationObserver(setupBlocks);
      observer.observe(document.body, { childList: true, subtree: true });
      document.addEventListener('cart:update', onCartEvent);
      scheduleSync();
    }

    function onCartEvent() {
      if (isSelfDispatch) return;
      scheduleSync();
    }

    function getCartSectionIds() {
      const all = document.querySelectorAll('[id^="shopify-section-"]');
      const ids = [];
      all.forEach(function (el) {
        const sectionId = el.id.replace('shopify-section-', '');
        const isCartRelated =
          el.querySelector('cart-drawer-component') ||
          el.querySelector('cart-items-component') ||
          el.querySelector('.cart-bubble') ||
          el.querySelector('[ref="cartBubble"]') ||
          sectionId.indexOf('cart') !== -1 ||
          sectionId === 'header';
        if (isCartRelated) ids.push(sectionId);
      });
      return ids;
    }

    function getSectionsParam() {
      return getCartSectionIds().join(',');
    }

    function applySections(sectionsHtml) {
      if (!sectionsHtml) return;
      Object.keys(sectionsHtml).forEach(function (sectionId) {
        const html = sectionsHtml[sectionId];
        if (!html) return;
        const target = document.getElementById('shopify-section-' + sectionId);
        if (!target) return;
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newNode = doc.getElementById('shopify-section-' + sectionId);
        if (newNode) target.replaceWith(newNode);
      });
    }

    function notifyCartUpdated(cart, sections) {
      isSelfDispatch = true;
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: 'klejn-gift-wrap',
          data: {
            source: 'klejn-gift-wrap',
            sections: sections || (cart && cart.sections) || null,
            itemCount: cart && cart.item_count
          }
        }
      }));
      setTimeout(function () { isSelfDispatch = false; }, 0);
    }

    function setupBlocks() {
      const blocks = document.querySelectorAll('[data-klejn-gw-block]:not([data-klejn-gw-ready])');
      blocks.forEach(setupBlock);
    }

    function setupBlock(block) {
      block.setAttribute('data-klejn-gw-ready', '');
      const toggle = block.querySelector('[data-klejn-gw-toggle]');
      const recipientWrap = block.querySelector('[data-klejn-gw-recipient-wrap]');
      const input = block.querySelector('[data-klejn-gw-input]');
      const errorEl = block.querySelector('[data-klejn-gw-error]');
      const required = block.dataset.klejnGwRecipientRequired === 'true';
      let touched = false;

      function getForms() {
        return document.querySelectorAll('form[action*="/cart/add"]');
      }

      function update() {
        const checked = toggle.checked;
        const recipient = (input.value || '').trim();
        const valid = !checked || !required || recipient.length > 0;
        const showInvalid = checked && !valid && touched;

        recipientWrap.hidden = !checked;
        block.classList.toggle('klejn-gw--invalid', showInvalid);

        if (errorEl) {
          errorEl.hidden = !showInvalid;
        }

        getForms().forEach(function (form) {
          let propInput = form.querySelector('input[data-klejn-gw-prop]');
          if (checked && recipient) {
            if (!propInput) {
              propInput = document.createElement('input');
              propInput.type = 'hidden';
              propInput.name = 'properties[' + PRODUCT_PROP + ']';
              propInput.setAttribute('data-klejn-gw-prop', '');
              form.appendChild(propInput);
            }
            propInput.value = recipient;
          } else if (propInput) {
            propInput.remove();
          }

          const submitBtn = form.querySelector('[type="submit"]');
          if (submitBtn) {
            if (checked && !valid) {
              submitBtn.dataset.klejnGwDisabled = '1';
              submitBtn.disabled = true;
            } else if (submitBtn.dataset.klejnGwDisabled) {
              delete submitBtn.dataset.klejnGwDisabled;
              submitBtn.disabled = false;
            }
          }
        });
      }

      toggle.addEventListener('change', function () {
        if (!toggle.checked) touched = false;
        update();
        if (toggle.checked) {
          requestAnimationFrame(function () { input.focus(); });
        }
      });
      input.addEventListener('input', function () {
        if (input.value.trim().length > 0) touched = true;
        update();
      });
      input.addEventListener('blur', function () {
        touched = true;
        update();
      });
      update();
    }

    function patchFetch() {
      window.fetch = async function (resource, init) {
        const result = await originalFetch(resource, init);
        try {
          const url = typeof resource === 'string' ? resource : resource && resource.url;
          const headers = (init && init.headers) || (resource && resource.headers);
          let isInternal = false;
          if (headers) {
            if (typeof headers.get === 'function') {
              isInternal = !!headers.get(INTERNAL_HEADER);
            } else {
              isInternal = !!headers[INTERNAL_HEADER];
            }
          }
          if (!isInternal && url && /\/cart\/(add|change|update|clear)/.test(url)) {
            scheduleSync();
          }
        } catch (e) {}
        return result;
      };
    }

    function scheduleSync() {
      if (syncTimer) clearTimeout(syncTimer);
      syncTimer = setTimeout(runSync, SYNC_DEBOUNCE_MS);
    }

    async function runSync() {
      if (syncing) {
        syncTimer = setTimeout(runSync, SYNC_DEBOUNCE_MS);
        return;
      }
      syncing = true;
      let changed = false;
      let lastSections = null;
      try {
        let wrapVariantId = getLocalVariantId();
        const cart = await fetchCart();

        if (wrapVariantId && cart.attributes && cart.attributes[VARIANT_ATTR] !== String(wrapVariantId)) {
          const r = await internalUpdate({ attributes: { [VARIANT_ATTR]: String(wrapVariantId) } });
          if (r && r.sections) lastSections = r.sections;
        }
        if (!wrapVariantId && cart.attributes) {
          const v = cart.attributes[VARIANT_ATTR];
          if (v) wrapVariantId = parseInt(v, 10);
        }
        if (!wrapVariantId) return;

        const productRecipients = new Set();
        const wrapsByRecipient = new Map();
        const productLinesByRecipient = new Map();

        cart.items.forEach(function (item) {
          if (item.variant_id === wrapVariantId) {
            const r = (item.properties && item.properties[WRAP_PROP]) || '';
            wrapsByRecipient.set(r, item);
          } else {
            const r = item.properties && item.properties[PRODUCT_PROP];
            if (r != null && r !== '') {
              productRecipients.add(r);
              const list = productLinesByRecipient.get(r) || [];
              list.push(item);
              productLinesByRecipient.set(r, list);
            }
          }
        });

        for (const [recipient, wrapItem] of wrapsByRecipient.entries()) {
          if (!productRecipients.has(recipient)) {
            const lines = productLinesByRecipient.get(recipient) || [];
            for (const line of lines) {
              const newProps = Object.assign({}, line.properties || {});
              delete newProps[PRODUCT_PROP];
              const r = await internalChange({
                id: line.key,
                properties: Object.keys(newProps).length ? newProps : {}
              });
              if (r && r.sections) lastSections = r.sections;
              changed = true;
            }
            const r = await internalChange({ id: wrapItem.key, quantity: 0 });
            if (r && r.sections) lastSections = r.sections;
            changed = true;
          }
        }

        for (const recipient of productRecipients) {
          if (!wrapsByRecipient.has(recipient)) {
            const r = await internalAdd({
              id: wrapVariantId,
              quantity: 1,
              properties: { [WRAP_PROP]: recipient }
            });
            if (r && r.sections) lastSections = r.sections;
            changed = true;
          }
        }

        if (productRecipients.size === 0 && cart.attributes && cart.attributes[VARIANT_ATTR]) {
          const r = await internalUpdate({ attributes: { [VARIANT_ATTR]: '' } });
          if (r && r.sections) lastSections = r.sections;
        }
      } catch (e) {
        console.error('[klejn-gw] sync failed', e);
      } finally {
        syncing = false;
        if (changed) {
          try {
            const sectionsParam = getSectionsParam();
            const url = sectionsParam
              ? '/cart.js?sections=' + encodeURIComponent(sectionsParam)
              : '/cart.js';
            const r = await originalFetch(url, { headers: { 'Accept': 'application/json' } });
            const finalCart = await r.json();
            applySections(finalCart.sections);
            notifyCartUpdated(finalCart, finalCart.sections);
          } catch (e) {
            applySections(lastSections);
            notifyCartUpdated(null, lastSections);
          }
        }
      }
    }

    function getLocalVariantId() {
      const block = document.querySelector('[data-klejn-gw-block]');
      if (!block) return null;
      const v = block.dataset.klejnGwVariantId;
      return v ? parseInt(v, 10) : null;
    }

    async function fetchCart() {
      const r = await originalFetch('/cart.js', {
        headers: { 'Accept': 'application/json' }
      });
      return await r.json();
    }
    function internalHeaders() {
      return {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        [INTERNAL_HEADER]: '1'
      };
    }
    function withSections(body) {
      const sections = getSectionsParam();
      return sections ? Object.assign({}, body, { sections: sections }) : body;
    }
    async function internalAdd(body) {
      const r = await originalFetch('/cart/add.js', {
        method: 'POST',
        headers: internalHeaders(),
        body: JSON.stringify(withSections(body))
      });
      if (!r.ok) return null;
      try { return await r.json(); } catch (e) { return null; }
    }
    async function internalChange(body) {
      const r = await originalFetch('/cart/change.js', {
        method: 'POST',
        headers: internalHeaders(),
        body: JSON.stringify(withSections(body))
      });
      if (!r.ok) return null;
      try { return await r.json(); } catch (e) { return null; }
    }
    async function internalUpdate(body) {
      const r = await originalFetch('/cart/update.js', {
        method: 'POST',
        headers: internalHeaders(),
        body: JSON.stringify(withSections(body))
      });
      if (!r.ok) return null;
      try { return await r.json(); } catch (e) { return null; }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
